module.exports = __webpack_public_path__ + "img/UI_loading_H5BG_02_222a19598.jpg";